/**
 * This file is automatically generated using generator/actions/generate-mapper.ts.
 * Do NOT modify this file by hand.
 */

import createServerTimeAction from 'api/actions/server-time/server-time-action';
import createValidateAccessTokenAction from 'api/actions/validate-access-token/validate-access-token-action';
import createLoginAction from 'api/actions/login/login-action';
import createLogoutAction from 'api/actions/logout/logout-action';
import createGetCurrentUserAction from 'api/actions/get-current-user/get-current-user-action';
import createUpdateSessionAction from 'api/actions/update-session/update-session-action';
import createUpdateUserDoorbellNameAction from 'api/actions/update-user-doorbell-name/update-user-doorbell-name-action';
import createGetCallOrderAction from 'api/actions/get-call-order/get-call-order-action';
import createUpdateCallOrderAction from 'api/actions/update-call-order/update-call-order-action';
import createUpdatePhoneNumberAction from 'api/actions/update-phone-number/update-phone-number-action';
import createUpdateSecondPhoneNumberAction from 'api/actions/update-second-phone-number/update-second-phone-number-action';
import createUpdateUserSettingsAction from 'api/actions/update-user-settings/update-user-settings-action';
import createGetUserPinAction from 'api/actions/get-user-pin/get-user-pin-action';
import createGetUserTemporaryPinCodesAction from 'api/actions/get-user-temporary-pin-codes/get-user-temporary-pin-codes-action';
import createCreateUserTemporaryPinCodeAction from 'api/actions/create-user-temporary-pin-code/create-user-temporary-pin-code-action';
import createCancelUserTemporaryPinCodeAction from 'api/actions/cancel-user-temporary-pin-code/cancel-user-temporary-pin-code-action';
import createGenerateUserPinAction from 'api/actions/generate-user-pin/generate-user-pin-action';
import createAdminGetUserPinAction from 'api/actions/admin-get-user-pin/admin-get-user-pin-action';
import createAdminRegenerateUserPinAction from 'api/actions/admin-regenerate-user-pin/admin-regenerate-user-pin-action';
import createAdminGetThermostatControlAction from 'api/actions/admin-get-thermostat-control/admin-get-thermostat-control-action';
import createAdminGetThermostatControlMeasurementsAction from 'api/actions/admin-get-thermostat-control-measurements/admin-get-thermostat-control-measurements-action';
import createAdminGetChastiaSensorChartAction from 'api/actions/admin-get-chastia-sensor-chart/admin-get-chastia-sensor-chart-action';
import createAdminGetChastiaSensorConsumptionChartAction from 'api/actions/admin-get-chastia-sensor-consumption-chart/admin-get-chastia-sensor-consumption-chart-action';
import createAdminCreateSipDoorMy2NDirectorySyncTaskAction from 'api/actions/admin-create-sip-door-my-2nd-irectory-sync-task/admin-create-sip-door-my-2nd-irectory-sync-task-action';
import createGetUserNotificationsAction from 'api/actions/get-user-notifications/get-user-notifications-action';
import createSeenNotificationAction from 'api/actions/seen-notification/seen-notification-action';
import createGetUserNotificationsCountAction from 'api/actions/get-user-notifications-count/get-user-notifications-count-action';
import createGetLicensePlatesAction from 'api/actions/get-license-plates/get-license-plates-action';
import createCreateLicensePlateAction from 'api/actions/create-license-plate/create-license-plate-action';
import createDeleteLicensePlateAction from 'api/actions/delete-license-plate/delete-license-plate-action';
import createUpdateLicensePlateAction from 'api/actions/update-license-plate/update-license-plate-action';
import createGetFamilyAction from 'api/actions/get-family/get-family-action';
import createAddFamilyMemberAction from 'api/actions/add-family-member/add-family-member-action';
import createUpdateFamilyMemberAction from 'api/actions/update-family-member/update-family-member-action';
import createDeleteFamilyMemberAction from 'api/actions/delete-family-member/delete-family-member-action';
import createGetFamilyMemberNotificationsAction from 'api/actions/get-family-member-notifications/get-family-member-notifications-action';
import createGetFamilyMemberPinAction from 'api/actions/get-family-member-pin/get-family-member-pin-action';
import createGetFamilyMemberTemporaryPinCodesAction from 'api/actions/get-family-member-temporary-pin-codes/get-family-member-temporary-pin-codes-action';
import createCreateFamilyMemberTemporaryPinCodeAction from 'api/actions/create-family-member-temporary-pin-code/create-family-member-temporary-pin-code-action';
import createCancelFamilyMemberTemporaryPinCodeAction from 'api/actions/cancel-family-member-temporary-pin-code/cancel-family-member-temporary-pin-code-action';
import createGenerateFamilyMemberPinAction from 'api/actions/generate-family-member-pin/generate-family-member-pin-action';
import createSendFamilyInviteEmailAction from 'api/actions/send-family-invite-email/send-family-invite-email-action';
import createGetRfidListAction from 'api/actions/get-rfid-list/get-rfid-list-action';
import createPairRfidAction from 'api/actions/pair-rfid/pair-rfid-action';
import createUnpairRfidAction from 'api/actions/unpair-rfid/unpair-rfid-action';
import createInitTotpAction from 'api/actions/init-totp/init-totp-action';
import createSetupTotpAction from 'api/actions/setup-totp/setup-totp-action';
import createGetFaqsAction from 'api/actions/get-faqs/get-faqs-action';
import createGetArticlesAction from 'api/actions/get-articles/get-articles-action';
import createGetArticleAction from 'api/actions/get-article/get-article-action';
import createHelpdeskGetJobsAction from 'api/actions/helpdesk-get-jobs/helpdesk-get-jobs-action';
import createCreateJobAction from 'api/actions/create-job/create-job-action';
import createHelpdeskGetJobCommentsAction from 'api/actions/helpdesk-get-job-comments/helpdesk-get-job-comments-action';
import createPostJobCommentAction from 'api/actions/post-job-comment/post-job-comment-action';
import createHelpdeskGetJobAttachmentsAction from 'api/actions/helpdesk-get-job-attachments/helpdesk-get-job-attachments-action';
import createPostJobAttachmentAction from 'api/actions/post-job-attachment/post-job-attachment-action';
import createHelpdeskSyncJobsAction from 'api/actions/helpdesk-sync-jobs/helpdesk-sync-jobs-action';
import createHelpdeskGetDocumentsAction from 'api/actions/helpdesk-get-documents/helpdesk-get-documents-action';
import createHelpdeskGetDocumentAction from 'api/actions/helpdesk-get-document/helpdesk-get-document-action';
import createHelpdeskGetAttachmentAction from 'api/actions/helpdesk-get-attachment/helpdesk-get-attachment-action';
import createHelpdeskSyncDocumentsAction from 'api/actions/helpdesk-sync-documents/helpdesk-sync-documents-action';
import createGetHelpdeskAreasAction from 'api/actions/get-helpdesk-areas/get-helpdesk-areas-action';
import createGetFileAction from 'api/actions/get-file/get-file-action';
import createGetFileByNameAction from 'api/actions/get-file-by-name/get-file-by-name-action';
import createInitPasswordResetAction from 'api/actions/init-password-reset/init-password-reset-action';
import createInitPasswordChangeAction from 'api/actions/init-password-change/init-password-change-action';
import createChangePasswordAction from 'api/actions/change-password/change-password-action';
import createGetSipDoorsAction from 'api/actions/get-sip-doors/get-sip-doors-action';
import createOpenSipDoorAction from 'api/actions/open-sip-door/open-sip-door-action';
import createDoorBellPressedAction from 'api/actions/door-bell-pressed/door-bell-pressed-action';
import createSipCallTerminatedAction from 'api/actions/sip-call-terminated/sip-call-terminated-action';
import createSipCallConnectingAction from 'api/actions/sip-call-connecting/sip-call-connecting-action';
import createSipCallVoipReceivedAction from 'api/actions/sip-call-voip-received/sip-call-voip-received-action';
import createSipCallSipConnectedAction from 'api/actions/sip-call-sip-connected/sip-call-sip-connected-action';
import createSipCallCallReceivedAction from 'api/actions/sip-call-call-received/sip-call-call-received-action';
import createGetCamerasAction from 'api/actions/get-cameras/get-cameras-action';
import createGetCameraLiveStreamAction from 'api/actions/get-camera-live-stream/get-camera-live-stream-action';
import createGetControlledEntriesAction from 'api/actions/get-controlled-entries/get-controlled-entries-action';
import createOpenControlledEntryAction from 'api/actions/open-controlled-entry/open-controlled-entry-action';
import createCloseControlledEntryAction from 'api/actions/close-controlled-entry/close-controlled-entry-action';
import createGetSensorsAction from 'api/actions/get-sensors/get-sensors-action';
import createGetSensorAction from 'api/actions/get-sensor/get-sensor-action';
import createGetSensorStatsAction from 'api/actions/get-sensor-stats/get-sensor-stats-action';
import createGetSensorAlertSettingsAction from 'api/actions/get-sensor-alert-settings/get-sensor-alert-settings-action';
import createUpdateSensorAlertSettingsAction from 'api/actions/update-sensor-alert-settings/update-sensor-alert-settings-action';
import createListElectricitySpotPricesAction from 'api/actions/list-electricity-spot-prices/list-electricity-spot-prices-action';
import createCompareElectricitySpotPricesAction from 'api/actions/compare-electricity-spot-prices/compare-electricity-spot-prices-action';
import createGetEnergyConsumptionAction from 'api/actions/get-energy-consumption/get-energy-consumption-action';
import createGetMonthlyEnergyStatsAction from 'api/actions/get-monthly-energy-stats/get-monthly-energy-stats-action';
import createGetTuyaDevicesAction from 'api/actions/get-tuya-devices/get-tuya-devices-action';
import createGetTuyaDeviceAction from 'api/actions/get-tuya-device/get-tuya-device-action';
import createCreateTuyaPairingSessionAction from 'api/actions/create-tuya-pairing-session/create-tuya-pairing-session-action';
import createGetTuyaPairingSessionAction from 'api/actions/get-tuya-pairing-session/get-tuya-pairing-session-action';
import createGetEvChargingStationAction from 'api/actions/get-ev-charging-station/get-ev-charging-station-action';
import createGetEvChargingSessionsAction from 'api/actions/get-ev-charging-sessions/get-ev-charging-sessions-action';
import createGetEvChargingSessionStatsAction from 'api/actions/get-ev-charging-session-stats/get-ev-charging-session-stats-action';
import createGetEvChargingStationLiveStatusAction from 'api/actions/get-ev-charging-station-live-status/get-ev-charging-station-live-status-action';
import createGetReservableSpacesAction from 'api/actions/get-reservable-spaces/get-reservable-spaces-action';
import createGetReservableSpaceAction from 'api/actions/get-reservable-space/get-reservable-space-action';
import createGetSpaceAvailabilityAction from 'api/actions/get-space-availability/get-space-availability-action';
import createGetPublicReservableSpaceAction from 'api/actions/get-public-reservable-space/get-public-reservable-space-action';
import createCreateBookingGuestRegistrationAction from 'api/actions/create-booking-guest-registration/create-booking-guest-registration-action';
import createActivateBookingGuestRegistrationAction from 'api/actions/activate-booking-guest-registration/activate-booking-guest-registration-action';
import createGetPublicSpaceAvailabilityAction from 'api/actions/get-public-space-availability/get-public-space-availability-action';
import createCreateGuestReservationAction from 'api/actions/create-guest-reservation/create-guest-reservation-action';
import createGetReservationsAction from 'api/actions/get-reservations/get-reservations-action';
import createCreateReservationAction from 'api/actions/create-reservation/create-reservation-action';
import createJoinBookingGuestSpaceAction from 'api/actions/join-booking-guest-space/join-booking-guest-space-action';
import createGetBookingAccountProfileAction from 'api/actions/get-booking-account-profile/get-booking-account-profile-action';
import createUpdateBookingAccountProfileAction from 'api/actions/update-booking-account-profile/update-booking-account-profile-action';
import createRequestBookingAccountEmailChangeAction from 'api/actions/request-booking-account-email-change/request-booking-account-email-change-action';
import createConfirmBookingAccountEmailChangeAction from 'api/actions/confirm-booking-account-email-change/confirm-booking-account-email-change-action';
import createGetMyReservationInvoicesAction from 'api/actions/get-my-reservation-invoices/get-my-reservation-invoices-action';
import createGetMyReservationInvoiceAction from 'api/actions/get-my-reservation-invoice/get-my-reservation-invoice-action';
import createGetMyReservationInvoicePdfAction from 'api/actions/get-my-reservation-invoice-pdf/get-my-reservation-invoice-pdf-action';
import createGetMyReservationCreditsAction from 'api/actions/get-my-reservation-credits/get-my-reservation-credits-action';
import createGetMyReservationCreditActivityAction from 'api/actions/get-my-reservation-credit-activity/get-my-reservation-credit-activity-action';
import createGetReservationCreditPurchasesAction from 'api/actions/get-reservation-credit-purchases/get-reservation-credit-purchases-action';
import createCreateReservationCreditPurchaseAction from 'api/actions/create-reservation-credit-purchase/create-reservation-credit-purchase-action';
import createGetReservationCreditPurchaseAction from 'api/actions/get-reservation-credit-purchase/get-reservation-credit-purchase-action';
import createRefreshReservationCreditPurchaseAction from 'api/actions/refresh-reservation-credit-purchase/refresh-reservation-credit-purchase-action';
import createCancelReservationCreditPurchaseAction from 'api/actions/cancel-reservation-credit-purchase/cancel-reservation-credit-purchase-action';
import createGetPublicBookingAction from 'api/actions/get-public-booking/get-public-booking-action';
import createGetPublicBookingCalendarAction from 'api/actions/get-public-booking-calendar/get-public-booking-calendar-action';
import createGetPublicBookingInvoicePdfAction from 'api/actions/get-public-booking-invoice-pdf/get-public-booking-invoice-pdf-action';
import createGetReservationDetailAction from 'api/actions/get-reservation-detail/get-reservation-detail-action';
import createGetReservationCalendarAction from 'api/actions/get-reservation-calendar/get-reservation-calendar-action';
import createCancelReservationAction from 'api/actions/cancel-reservation/cancel-reservation-action';
import createManageReservationGuestAccessAction from 'api/actions/manage-reservation-guest-access/manage-reservation-guest-access-action';
import createGetReservationPaymentAction from 'api/actions/get-reservation-payment/get-reservation-payment-action';
import createRefreshReservationPaymentAction from 'api/actions/refresh-reservation-payment/refresh-reservation-payment-action';
import createGetPublicReservationPaymentAction from 'api/actions/get-public-reservation-payment/get-public-reservation-payment-action';
import createRefreshPublicReservationPaymentAction from 'api/actions/refresh-public-reservation-payment/refresh-public-reservation-payment-action';
import createGetReservationInvoicePdfAction from 'api/actions/get-reservation-invoice-pdf/get-reservation-invoice-pdf-action';
import createGetReservationInvoiceIsdocAction from 'api/actions/get-reservation-invoice-isdoc/get-reservation-invoice-isdoc-action';
import createGetPublicReservationInvoicePdfAction from 'api/actions/get-public-reservation-invoice-pdf/get-public-reservation-invoice-pdf-action';
import createGetPublicReservationInvoiceIsdocAction from 'api/actions/get-public-reservation-invoice-isdoc/get-public-reservation-invoice-isdoc-action';
import createAcceptReservationAction from 'api/actions/accept-reservation/accept-reservation-action';
import createMarkReservationPaidAction from 'api/actions/mark-reservation-paid/mark-reservation-paid-action';
import createMarkReservationCreditPurchasePaidAction from 'api/actions/mark-reservation-credit-purchase-paid/mark-reservation-credit-purchase-paid-action';
import createCreateManualCreditGrantAction from 'api/actions/create-manual-credit-grant/create-manual-credit-grant-action';
import createGetReservableSpaceStatisticsAction from 'api/actions/get-reservable-space-statistics/get-reservable-space-statistics-action';
import createGetAirConditionerAction from 'api/actions/get-air-conditioner/get-air-conditioner-action';
import createSetAirConditionerCharacteristicAction from 'api/actions/set-air-conditioner-characteristic/set-air-conditioner-characteristic-action';
import createGetDaikinAuthStatusAction from 'api/actions/get-daikin-auth-status/get-daikin-auth-status-action';
import createStartDaikinAuthAction from 'api/actions/start-daikin-auth/start-daikin-auth-action';
import createSyncDaikinDevicesAction from 'api/actions/sync-daikin-devices/sync-daikin-devices-action';
import { AxiosInstance } from 'axios';

/**
 * All action names.
 */
export type ActionName =
  | 'ServerTime'
  | 'ValidateAccessToken'
  | 'Login'
  | 'Logout'
  | 'GetCurrentUser'
  | 'UpdateSession'
  | 'UpdateUserDoorbellName'
  | 'GetCallOrder'
  | 'UpdateCallOrder'
  | 'UpdatePhoneNumber'
  | 'UpdateSecondPhoneNumber'
  | 'UpdateUserSettings'
  | 'GetUserPin'
  | 'GetUserTemporaryPinCodes'
  | 'CreateUserTemporaryPinCode'
  | 'CancelUserTemporaryPinCode'
  | 'GenerateUserPin'
  | 'AdminGetUserPin'
  | 'AdminRegenerateUserPin'
  | 'AdminGetThermostatControl'
  | 'AdminGetThermostatControlMeasurements'
  | 'AdminGetChastiaSensorChart'
  | 'AdminGetChastiaSensorConsumptionChart'
  | 'AdminCreateSipDoorMy2NDirectorySyncTask'
  | 'GetUserNotifications'
  | 'SeenNotification'
  | 'GetUserNotificationsCount'
  | 'GetLicensePlates'
  | 'CreateLicensePlate'
  | 'DeleteLicensePlate'
  | 'UpdateLicensePlate'
  | 'GetFamily'
  | 'AddFamilyMember'
  | 'UpdateFamilyMember'
  | 'DeleteFamilyMember'
  | 'GetFamilyMemberNotifications'
  | 'GetFamilyMemberPin'
  | 'GetFamilyMemberTemporaryPinCodes'
  | 'CreateFamilyMemberTemporaryPinCode'
  | 'CancelFamilyMemberTemporaryPinCode'
  | 'GenerateFamilyMemberPin'
  | 'SendFamilyInviteEmail'
  | 'GetRfidList'
  | 'PairRfid'
  | 'UnpairRfid'
  | 'InitTotp'
  | 'SetupTotp'
  | 'GetFaqs'
  | 'GetArticles'
  | 'GetArticle'
  | 'HelpdeskGetJobs'
  | 'CreateJob'
  | 'HelpdeskGetJobComments'
  | 'PostJobComment'
  | 'HelpdeskGetJobAttachments'
  | 'PostJobAttachment'
  | 'HelpdeskSyncJobs'
  | 'HelpdeskGetDocuments'
  | 'HelpdeskGetDocument'
  | 'HelpdeskGetAttachment'
  | 'HelpdeskSyncDocuments'
  | 'GetHelpdeskAreas'
  | 'GetFile'
  | 'GetFileByName'
  | 'InitPasswordReset'
  | 'InitPasswordChange'
  | 'ChangePassword'
  | 'GetSipDoors'
  | 'OpenSipDoor'
  | 'DoorBellPressed'
  | 'SipCallTerminated'
  | 'SipCallConnecting'
  | 'SipCallVoipReceived'
  | 'SipCallSipConnected'
  | 'SipCallCallReceived'
  | 'GetCameras'
  | 'GetCameraLiveStream'
  | 'GetControlledEntries'
  | 'OpenControlledEntry'
  | 'CloseControlledEntry'
  | 'GetSensors'
  | 'GetSensor'
  | 'GetSensorStats'
  | 'GetSensorAlertSettings'
  | 'UpdateSensorAlertSettings'
  | 'ListElectricitySpotPrices'
  | 'CompareElectricitySpotPrices'
  | 'GetEnergyConsumption'
  | 'GetMonthlyEnergyStats'
  | 'GetTuyaDevices'
  | 'GetTuyaDevice'
  | 'CreateTuyaPairingSession'
  | 'GetTuyaPairingSession'
  | 'GetEvChargingStation'
  | 'GetEvChargingSessions'
  | 'GetEvChargingSessionStats'
  | 'GetEvChargingStationLiveStatus'
  | 'GetReservableSpaces'
  | 'GetReservableSpace'
  | 'GetSpaceAvailability'
  | 'GetPublicReservableSpace'
  | 'CreateBookingGuestRegistration'
  | 'ActivateBookingGuestRegistration'
  | 'GetPublicSpaceAvailability'
  | 'CreateGuestReservation'
  | 'GetReservations'
  | 'CreateReservation'
  | 'JoinBookingGuestSpace'
  | 'GetBookingAccountProfile'
  | 'UpdateBookingAccountProfile'
  | 'RequestBookingAccountEmailChange'
  | 'ConfirmBookingAccountEmailChange'
  | 'GetMyReservationInvoices'
  | 'GetMyReservationInvoice'
  | 'GetMyReservationInvoicePdf'
  | 'GetMyReservationCredits'
  | 'GetMyReservationCreditActivity'
  | 'GetReservationCreditPurchases'
  | 'CreateReservationCreditPurchase'
  | 'GetReservationCreditPurchase'
  | 'RefreshReservationCreditPurchase'
  | 'CancelReservationCreditPurchase'
  | 'GetPublicBooking'
  | 'GetPublicBookingCalendar'
  | 'GetPublicBookingInvoicePdf'
  | 'GetReservationDetail'
  | 'GetReservationCalendar'
  | 'CancelReservation'
  | 'ManageReservationGuestAccess'
  | 'GetReservationPayment'
  | 'RefreshReservationPayment'
  | 'GetPublicReservationPayment'
  | 'RefreshPublicReservationPayment'
  | 'GetReservationInvoicePdf'
  | 'GetReservationInvoiceIsdoc'
  | 'GetPublicReservationInvoicePdf'
  | 'GetPublicReservationInvoiceIsdoc'
  | 'AcceptReservation'
  | 'MarkReservationPaid'
  | 'MarkReservationCreditPurchasePaid'
  | 'CreateManualCreditGrant'
  | 'GetReservableSpaceStatistics'
  | 'GetAirConditioner'
  | 'SetAirConditionerCharacteristic'
  | 'GetDaikinAuthStatus'
  | 'StartDaikinAuth'
  | 'SyncDaikinDevices';

/**
 * Overloads for the getAction function.
 */
export type GetActionMap = ((action: 'ServerTime') => ReturnType<typeof createServerTimeAction>) &
  ((action: 'ValidateAccessToken') => ReturnType<typeof createValidateAccessTokenAction>) &
  ((action: 'Login') => ReturnType<typeof createLoginAction>) &
  ((action: 'Logout') => ReturnType<typeof createLogoutAction>) &
  ((action: 'GetCurrentUser') => ReturnType<typeof createGetCurrentUserAction>) &
  ((action: 'UpdateSession') => ReturnType<typeof createUpdateSessionAction>) &
  ((action: 'UpdateUserDoorbellName') => ReturnType<typeof createUpdateUserDoorbellNameAction>) &
  ((action: 'GetCallOrder') => ReturnType<typeof createGetCallOrderAction>) &
  ((action: 'UpdateCallOrder') => ReturnType<typeof createUpdateCallOrderAction>) &
  ((action: 'UpdatePhoneNumber') => ReturnType<typeof createUpdatePhoneNumberAction>) &
  ((action: 'UpdateSecondPhoneNumber') => ReturnType<typeof createUpdateSecondPhoneNumberAction>) &
  ((action: 'UpdateUserSettings') => ReturnType<typeof createUpdateUserSettingsAction>) &
  ((action: 'GetUserPin') => ReturnType<typeof createGetUserPinAction>) &
  ((action: 'GetUserTemporaryPinCodes') => ReturnType<typeof createGetUserTemporaryPinCodesAction>) &
  ((action: 'CreateUserTemporaryPinCode') => ReturnType<typeof createCreateUserTemporaryPinCodeAction>) &
  ((action: 'CancelUserTemporaryPinCode') => ReturnType<typeof createCancelUserTemporaryPinCodeAction>) &
  ((action: 'GenerateUserPin') => ReturnType<typeof createGenerateUserPinAction>) &
  ((action: 'AdminGetUserPin') => ReturnType<typeof createAdminGetUserPinAction>) &
  ((action: 'AdminRegenerateUserPin') => ReturnType<typeof createAdminRegenerateUserPinAction>) &
  ((action: 'AdminGetThermostatControl') => ReturnType<typeof createAdminGetThermostatControlAction>) &
  ((
    action: 'AdminGetThermostatControlMeasurements'
  ) => ReturnType<typeof createAdminGetThermostatControlMeasurementsAction>) &
  ((action: 'AdminGetChastiaSensorChart') => ReturnType<typeof createAdminGetChastiaSensorChartAction>) &
  ((
    action: 'AdminGetChastiaSensorConsumptionChart'
  ) => ReturnType<typeof createAdminGetChastiaSensorConsumptionChartAction>) &
  ((
    action: 'AdminCreateSipDoorMy2NDirectorySyncTask'
  ) => ReturnType<typeof createAdminCreateSipDoorMy2NDirectorySyncTaskAction>) &
  ((action: 'GetUserNotifications') => ReturnType<typeof createGetUserNotificationsAction>) &
  ((action: 'SeenNotification') => ReturnType<typeof createSeenNotificationAction>) &
  ((action: 'GetUserNotificationsCount') => ReturnType<typeof createGetUserNotificationsCountAction>) &
  ((action: 'GetLicensePlates') => ReturnType<typeof createGetLicensePlatesAction>) &
  ((action: 'CreateLicensePlate') => ReturnType<typeof createCreateLicensePlateAction>) &
  ((action: 'DeleteLicensePlate') => ReturnType<typeof createDeleteLicensePlateAction>) &
  ((action: 'UpdateLicensePlate') => ReturnType<typeof createUpdateLicensePlateAction>) &
  ((action: 'GetFamily') => ReturnType<typeof createGetFamilyAction>) &
  ((action: 'AddFamilyMember') => ReturnType<typeof createAddFamilyMemberAction>) &
  ((action: 'UpdateFamilyMember') => ReturnType<typeof createUpdateFamilyMemberAction>) &
  ((action: 'DeleteFamilyMember') => ReturnType<typeof createDeleteFamilyMemberAction>) &
  ((action: 'GetFamilyMemberNotifications') => ReturnType<typeof createGetFamilyMemberNotificationsAction>) &
  ((action: 'GetFamilyMemberPin') => ReturnType<typeof createGetFamilyMemberPinAction>) &
  ((action: 'GetFamilyMemberTemporaryPinCodes') => ReturnType<typeof createGetFamilyMemberTemporaryPinCodesAction>) &
  ((
    action: 'CreateFamilyMemberTemporaryPinCode'
  ) => ReturnType<typeof createCreateFamilyMemberTemporaryPinCodeAction>) &
  ((
    action: 'CancelFamilyMemberTemporaryPinCode'
  ) => ReturnType<typeof createCancelFamilyMemberTemporaryPinCodeAction>) &
  ((action: 'GenerateFamilyMemberPin') => ReturnType<typeof createGenerateFamilyMemberPinAction>) &
  ((action: 'SendFamilyInviteEmail') => ReturnType<typeof createSendFamilyInviteEmailAction>) &
  ((action: 'GetRfidList') => ReturnType<typeof createGetRfidListAction>) &
  ((action: 'PairRfid') => ReturnType<typeof createPairRfidAction>) &
  ((action: 'UnpairRfid') => ReturnType<typeof createUnpairRfidAction>) &
  ((action: 'InitTotp') => ReturnType<typeof createInitTotpAction>) &
  ((action: 'SetupTotp') => ReturnType<typeof createSetupTotpAction>) &
  ((action: 'GetFaqs') => ReturnType<typeof createGetFaqsAction>) &
  ((action: 'GetArticles') => ReturnType<typeof createGetArticlesAction>) &
  ((action: 'GetArticle') => ReturnType<typeof createGetArticleAction>) &
  ((action: 'HelpdeskGetJobs') => ReturnType<typeof createHelpdeskGetJobsAction>) &
  ((action: 'CreateJob') => ReturnType<typeof createCreateJobAction>) &
  ((action: 'HelpdeskGetJobComments') => ReturnType<typeof createHelpdeskGetJobCommentsAction>) &
  ((action: 'PostJobComment') => ReturnType<typeof createPostJobCommentAction>) &
  ((action: 'HelpdeskGetJobAttachments') => ReturnType<typeof createHelpdeskGetJobAttachmentsAction>) &
  ((action: 'PostJobAttachment') => ReturnType<typeof createPostJobAttachmentAction>) &
  ((action: 'HelpdeskSyncJobs') => ReturnType<typeof createHelpdeskSyncJobsAction>) &
  ((action: 'HelpdeskGetDocuments') => ReturnType<typeof createHelpdeskGetDocumentsAction>) &
  ((action: 'HelpdeskGetDocument') => ReturnType<typeof createHelpdeskGetDocumentAction>) &
  ((action: 'HelpdeskGetAttachment') => ReturnType<typeof createHelpdeskGetAttachmentAction>) &
  ((action: 'HelpdeskSyncDocuments') => ReturnType<typeof createHelpdeskSyncDocumentsAction>) &
  ((action: 'GetHelpdeskAreas') => ReturnType<typeof createGetHelpdeskAreasAction>) &
  ((action: 'GetFile') => ReturnType<typeof createGetFileAction>) &
  ((action: 'GetFileByName') => ReturnType<typeof createGetFileByNameAction>) &
  ((action: 'InitPasswordReset') => ReturnType<typeof createInitPasswordResetAction>) &
  ((action: 'InitPasswordChange') => ReturnType<typeof createInitPasswordChangeAction>) &
  ((action: 'ChangePassword') => ReturnType<typeof createChangePasswordAction>) &
  ((action: 'GetSipDoors') => ReturnType<typeof createGetSipDoorsAction>) &
  ((action: 'OpenSipDoor') => ReturnType<typeof createOpenSipDoorAction>) &
  ((action: 'DoorBellPressed') => ReturnType<typeof createDoorBellPressedAction>) &
  ((action: 'SipCallTerminated') => ReturnType<typeof createSipCallTerminatedAction>) &
  ((action: 'SipCallConnecting') => ReturnType<typeof createSipCallConnectingAction>) &
  ((action: 'SipCallVoipReceived') => ReturnType<typeof createSipCallVoipReceivedAction>) &
  ((action: 'SipCallSipConnected') => ReturnType<typeof createSipCallSipConnectedAction>) &
  ((action: 'SipCallCallReceived') => ReturnType<typeof createSipCallCallReceivedAction>) &
  ((action: 'GetCameras') => ReturnType<typeof createGetCamerasAction>) &
  ((action: 'GetCameraLiveStream') => ReturnType<typeof createGetCameraLiveStreamAction>) &
  ((action: 'GetControlledEntries') => ReturnType<typeof createGetControlledEntriesAction>) &
  ((action: 'OpenControlledEntry') => ReturnType<typeof createOpenControlledEntryAction>) &
  ((action: 'CloseControlledEntry') => ReturnType<typeof createCloseControlledEntryAction>) &
  ((action: 'GetSensors') => ReturnType<typeof createGetSensorsAction>) &
  ((action: 'GetSensor') => ReturnType<typeof createGetSensorAction>) &
  ((action: 'GetSensorStats') => ReturnType<typeof createGetSensorStatsAction>) &
  ((action: 'GetSensorAlertSettings') => ReturnType<typeof createGetSensorAlertSettingsAction>) &
  ((action: 'UpdateSensorAlertSettings') => ReturnType<typeof createUpdateSensorAlertSettingsAction>) &
  ((action: 'ListElectricitySpotPrices') => ReturnType<typeof createListElectricitySpotPricesAction>) &
  ((action: 'CompareElectricitySpotPrices') => ReturnType<typeof createCompareElectricitySpotPricesAction>) &
  ((action: 'GetEnergyConsumption') => ReturnType<typeof createGetEnergyConsumptionAction>) &
  ((action: 'GetMonthlyEnergyStats') => ReturnType<typeof createGetMonthlyEnergyStatsAction>) &
  ((action: 'GetTuyaDevices') => ReturnType<typeof createGetTuyaDevicesAction>) &
  ((action: 'GetTuyaDevice') => ReturnType<typeof createGetTuyaDeviceAction>) &
  ((action: 'CreateTuyaPairingSession') => ReturnType<typeof createCreateTuyaPairingSessionAction>) &
  ((action: 'GetTuyaPairingSession') => ReturnType<typeof createGetTuyaPairingSessionAction>) &
  ((action: 'GetEvChargingStation') => ReturnType<typeof createGetEvChargingStationAction>) &
  ((action: 'GetEvChargingSessions') => ReturnType<typeof createGetEvChargingSessionsAction>) &
  ((action: 'GetEvChargingSessionStats') => ReturnType<typeof createGetEvChargingSessionStatsAction>) &
  ((action: 'GetEvChargingStationLiveStatus') => ReturnType<typeof createGetEvChargingStationLiveStatusAction>) &
  ((action: 'GetReservableSpaces') => ReturnType<typeof createGetReservableSpacesAction>) &
  ((action: 'GetReservableSpace') => ReturnType<typeof createGetReservableSpaceAction>) &
  ((action: 'GetSpaceAvailability') => ReturnType<typeof createGetSpaceAvailabilityAction>) &
  ((action: 'GetPublicReservableSpace') => ReturnType<typeof createGetPublicReservableSpaceAction>) &
  ((action: 'CreateBookingGuestRegistration') => ReturnType<typeof createCreateBookingGuestRegistrationAction>) &
  ((action: 'ActivateBookingGuestRegistration') => ReturnType<typeof createActivateBookingGuestRegistrationAction>) &
  ((action: 'GetPublicSpaceAvailability') => ReturnType<typeof createGetPublicSpaceAvailabilityAction>) &
  ((action: 'CreateGuestReservation') => ReturnType<typeof createCreateGuestReservationAction>) &
  ((action: 'GetReservations') => ReturnType<typeof createGetReservationsAction>) &
  ((action: 'CreateReservation') => ReturnType<typeof createCreateReservationAction>) &
  ((action: 'JoinBookingGuestSpace') => ReturnType<typeof createJoinBookingGuestSpaceAction>) &
  ((action: 'GetBookingAccountProfile') => ReturnType<typeof createGetBookingAccountProfileAction>) &
  ((action: 'UpdateBookingAccountProfile') => ReturnType<typeof createUpdateBookingAccountProfileAction>) &
  ((action: 'RequestBookingAccountEmailChange') => ReturnType<typeof createRequestBookingAccountEmailChangeAction>) &
  ((action: 'ConfirmBookingAccountEmailChange') => ReturnType<typeof createConfirmBookingAccountEmailChangeAction>) &
  ((action: 'GetMyReservationInvoices') => ReturnType<typeof createGetMyReservationInvoicesAction>) &
  ((action: 'GetMyReservationInvoice') => ReturnType<typeof createGetMyReservationInvoiceAction>) &
  ((action: 'GetMyReservationInvoicePdf') => ReturnType<typeof createGetMyReservationInvoicePdfAction>) &
  ((action: 'GetMyReservationCredits') => ReturnType<typeof createGetMyReservationCreditsAction>) &
  ((action: 'GetMyReservationCreditActivity') => ReturnType<typeof createGetMyReservationCreditActivityAction>) &
  ((action: 'GetReservationCreditPurchases') => ReturnType<typeof createGetReservationCreditPurchasesAction>) &
  ((action: 'CreateReservationCreditPurchase') => ReturnType<typeof createCreateReservationCreditPurchaseAction>) &
  ((action: 'GetReservationCreditPurchase') => ReturnType<typeof createGetReservationCreditPurchaseAction>) &
  ((action: 'RefreshReservationCreditPurchase') => ReturnType<typeof createRefreshReservationCreditPurchaseAction>) &
  ((action: 'CancelReservationCreditPurchase') => ReturnType<typeof createCancelReservationCreditPurchaseAction>) &
  ((action: 'GetPublicBooking') => ReturnType<typeof createGetPublicBookingAction>) &
  ((action: 'GetPublicBookingCalendar') => ReturnType<typeof createGetPublicBookingCalendarAction>) &
  ((action: 'GetPublicBookingInvoicePdf') => ReturnType<typeof createGetPublicBookingInvoicePdfAction>) &
  ((action: 'GetReservationDetail') => ReturnType<typeof createGetReservationDetailAction>) &
  ((action: 'GetReservationCalendar') => ReturnType<typeof createGetReservationCalendarAction>) &
  ((action: 'CancelReservation') => ReturnType<typeof createCancelReservationAction>) &
  ((action: 'ManageReservationGuestAccess') => ReturnType<typeof createManageReservationGuestAccessAction>) &
  ((action: 'GetReservationPayment') => ReturnType<typeof createGetReservationPaymentAction>) &
  ((action: 'RefreshReservationPayment') => ReturnType<typeof createRefreshReservationPaymentAction>) &
  ((action: 'GetPublicReservationPayment') => ReturnType<typeof createGetPublicReservationPaymentAction>) &
  ((action: 'RefreshPublicReservationPayment') => ReturnType<typeof createRefreshPublicReservationPaymentAction>) &
  ((action: 'GetReservationInvoicePdf') => ReturnType<typeof createGetReservationInvoicePdfAction>) &
  ((action: 'GetReservationInvoiceIsdoc') => ReturnType<typeof createGetReservationInvoiceIsdocAction>) &
  ((action: 'GetPublicReservationInvoicePdf') => ReturnType<typeof createGetPublicReservationInvoicePdfAction>) &
  ((action: 'GetPublicReservationInvoiceIsdoc') => ReturnType<typeof createGetPublicReservationInvoiceIsdocAction>) &
  ((action: 'AcceptReservation') => ReturnType<typeof createAcceptReservationAction>) &
  ((action: 'MarkReservationPaid') => ReturnType<typeof createMarkReservationPaidAction>) &
  ((action: 'MarkReservationCreditPurchasePaid') => ReturnType<typeof createMarkReservationCreditPurchasePaidAction>) &
  ((action: 'CreateManualCreditGrant') => ReturnType<typeof createCreateManualCreditGrantAction>) &
  ((action: 'GetReservableSpaceStatistics') => ReturnType<typeof createGetReservableSpaceStatisticsAction>) &
  ((action: 'GetAirConditioner') => ReturnType<typeof createGetAirConditionerAction>) &
  ((action: 'SetAirConditionerCharacteristic') => ReturnType<typeof createSetAirConditionerCharacteristicAction>) &
  ((action: 'GetDaikinAuthStatus') => ReturnType<typeof createGetDaikinAuthStatusAction>) &
  ((action: 'StartDaikinAuth') => ReturnType<typeof createStartDaikinAuthAction>) &
  ((action: 'SyncDaikinDevices') => ReturnType<typeof createSyncDaikinDevicesAction>);

/**
 * The map from action name to action creator.
 */
export const actions: Map<ActionName, (axios: AxiosInstance) => Promise<any>> = new Map([
  ['ServerTime', createServerTimeAction],
  ['ValidateAccessToken', createValidateAccessTokenAction],
  ['Login', createLoginAction],
  ['Logout', createLogoutAction],
  ['GetCurrentUser', createGetCurrentUserAction],
  ['UpdateSession', createUpdateSessionAction],
  ['UpdateUserDoorbellName', createUpdateUserDoorbellNameAction],
  ['GetCallOrder', createGetCallOrderAction],
  ['UpdateCallOrder', createUpdateCallOrderAction],
  ['UpdatePhoneNumber', createUpdatePhoneNumberAction],
  ['UpdateSecondPhoneNumber', createUpdateSecondPhoneNumberAction],
  ['UpdateUserSettings', createUpdateUserSettingsAction],
  ['GetUserPin', createGetUserPinAction],
  ['GetUserTemporaryPinCodes', createGetUserTemporaryPinCodesAction],
  ['CreateUserTemporaryPinCode', createCreateUserTemporaryPinCodeAction],
  ['CancelUserTemporaryPinCode', createCancelUserTemporaryPinCodeAction],
  ['GenerateUserPin', createGenerateUserPinAction],
  ['AdminGetUserPin', createAdminGetUserPinAction],
  ['AdminRegenerateUserPin', createAdminRegenerateUserPinAction],
  ['AdminGetThermostatControl', createAdminGetThermostatControlAction],
  ['AdminGetThermostatControlMeasurements', createAdminGetThermostatControlMeasurementsAction],
  ['AdminGetChastiaSensorChart', createAdminGetChastiaSensorChartAction],
  ['AdminGetChastiaSensorConsumptionChart', createAdminGetChastiaSensorConsumptionChartAction],
  ['AdminCreateSipDoorMy2NDirectorySyncTask', createAdminCreateSipDoorMy2NDirectorySyncTaskAction],
  ['GetUserNotifications', createGetUserNotificationsAction],
  ['SeenNotification', createSeenNotificationAction],
  ['GetUserNotificationsCount', createGetUserNotificationsCountAction],
  ['GetLicensePlates', createGetLicensePlatesAction],
  ['CreateLicensePlate', createCreateLicensePlateAction],
  ['DeleteLicensePlate', createDeleteLicensePlateAction],
  ['UpdateLicensePlate', createUpdateLicensePlateAction],
  ['GetFamily', createGetFamilyAction],
  ['AddFamilyMember', createAddFamilyMemberAction],
  ['UpdateFamilyMember', createUpdateFamilyMemberAction],
  ['DeleteFamilyMember', createDeleteFamilyMemberAction],
  ['GetFamilyMemberNotifications', createGetFamilyMemberNotificationsAction],
  ['GetFamilyMemberPin', createGetFamilyMemberPinAction],
  ['GetFamilyMemberTemporaryPinCodes', createGetFamilyMemberTemporaryPinCodesAction],
  ['CreateFamilyMemberTemporaryPinCode', createCreateFamilyMemberTemporaryPinCodeAction],
  ['CancelFamilyMemberTemporaryPinCode', createCancelFamilyMemberTemporaryPinCodeAction],
  ['GenerateFamilyMemberPin', createGenerateFamilyMemberPinAction],
  ['SendFamilyInviteEmail', createSendFamilyInviteEmailAction],
  ['GetRfidList', createGetRfidListAction],
  ['PairRfid', createPairRfidAction],
  ['UnpairRfid', createUnpairRfidAction],
  ['InitTotp', createInitTotpAction],
  ['SetupTotp', createSetupTotpAction],
  ['GetFaqs', createGetFaqsAction],
  ['GetArticles', createGetArticlesAction],
  ['GetArticle', createGetArticleAction],
  ['HelpdeskGetJobs', createHelpdeskGetJobsAction],
  ['CreateJob', createCreateJobAction],
  ['HelpdeskGetJobComments', createHelpdeskGetJobCommentsAction],
  ['PostJobComment', createPostJobCommentAction],
  ['HelpdeskGetJobAttachments', createHelpdeskGetJobAttachmentsAction],
  ['PostJobAttachment', createPostJobAttachmentAction],
  ['HelpdeskSyncJobs', createHelpdeskSyncJobsAction],
  ['HelpdeskGetDocuments', createHelpdeskGetDocumentsAction],
  ['HelpdeskGetDocument', createHelpdeskGetDocumentAction],
  ['HelpdeskGetAttachment', createHelpdeskGetAttachmentAction],
  ['HelpdeskSyncDocuments', createHelpdeskSyncDocumentsAction],
  ['GetHelpdeskAreas', createGetHelpdeskAreasAction],
  ['GetFile', createGetFileAction],
  ['GetFileByName', createGetFileByNameAction],
  ['InitPasswordReset', createInitPasswordResetAction],
  ['InitPasswordChange', createInitPasswordChangeAction],
  ['ChangePassword', createChangePasswordAction],
  ['GetSipDoors', createGetSipDoorsAction],
  ['OpenSipDoor', createOpenSipDoorAction],
  ['DoorBellPressed', createDoorBellPressedAction],
  ['SipCallTerminated', createSipCallTerminatedAction],
  ['SipCallConnecting', createSipCallConnectingAction],
  ['SipCallVoipReceived', createSipCallVoipReceivedAction],
  ['SipCallSipConnected', createSipCallSipConnectedAction],
  ['SipCallCallReceived', createSipCallCallReceivedAction],
  ['GetCameras', createGetCamerasAction],
  ['GetCameraLiveStream', createGetCameraLiveStreamAction],
  ['GetControlledEntries', createGetControlledEntriesAction],
  ['OpenControlledEntry', createOpenControlledEntryAction],
  ['CloseControlledEntry', createCloseControlledEntryAction],
  ['GetSensors', createGetSensorsAction],
  ['GetSensor', createGetSensorAction],
  ['GetSensorStats', createGetSensorStatsAction],
  ['GetSensorAlertSettings', createGetSensorAlertSettingsAction],
  ['UpdateSensorAlertSettings', createUpdateSensorAlertSettingsAction],
  ['ListElectricitySpotPrices', createListElectricitySpotPricesAction],
  ['CompareElectricitySpotPrices', createCompareElectricitySpotPricesAction],
  ['GetEnergyConsumption', createGetEnergyConsumptionAction],
  ['GetMonthlyEnergyStats', createGetMonthlyEnergyStatsAction],
  ['GetTuyaDevices', createGetTuyaDevicesAction],
  ['GetTuyaDevice', createGetTuyaDeviceAction],
  ['CreateTuyaPairingSession', createCreateTuyaPairingSessionAction],
  ['GetTuyaPairingSession', createGetTuyaPairingSessionAction],
  ['GetEvChargingStation', createGetEvChargingStationAction],
  ['GetEvChargingSessions', createGetEvChargingSessionsAction],
  ['GetEvChargingSessionStats', createGetEvChargingSessionStatsAction],
  ['GetEvChargingStationLiveStatus', createGetEvChargingStationLiveStatusAction],
  ['GetReservableSpaces', createGetReservableSpacesAction],
  ['GetReservableSpace', createGetReservableSpaceAction],
  ['GetSpaceAvailability', createGetSpaceAvailabilityAction],
  ['GetPublicReservableSpace', createGetPublicReservableSpaceAction],
  ['CreateBookingGuestRegistration', createCreateBookingGuestRegistrationAction],
  ['ActivateBookingGuestRegistration', createActivateBookingGuestRegistrationAction],
  ['GetPublicSpaceAvailability', createGetPublicSpaceAvailabilityAction],
  ['CreateGuestReservation', createCreateGuestReservationAction],
  ['GetReservations', createGetReservationsAction],
  ['CreateReservation', createCreateReservationAction],
  ['JoinBookingGuestSpace', createJoinBookingGuestSpaceAction],
  ['GetBookingAccountProfile', createGetBookingAccountProfileAction],
  ['UpdateBookingAccountProfile', createUpdateBookingAccountProfileAction],
  ['RequestBookingAccountEmailChange', createRequestBookingAccountEmailChangeAction],
  ['ConfirmBookingAccountEmailChange', createConfirmBookingAccountEmailChangeAction],
  ['GetMyReservationInvoices', createGetMyReservationInvoicesAction],
  ['GetMyReservationInvoice', createGetMyReservationInvoiceAction],
  ['GetMyReservationInvoicePdf', createGetMyReservationInvoicePdfAction],
  ['GetMyReservationCredits', createGetMyReservationCreditsAction],
  ['GetMyReservationCreditActivity', createGetMyReservationCreditActivityAction],
  ['GetReservationCreditPurchases', createGetReservationCreditPurchasesAction],
  ['CreateReservationCreditPurchase', createCreateReservationCreditPurchaseAction],
  ['GetReservationCreditPurchase', createGetReservationCreditPurchaseAction],
  ['RefreshReservationCreditPurchase', createRefreshReservationCreditPurchaseAction],
  ['CancelReservationCreditPurchase', createCancelReservationCreditPurchaseAction],
  ['GetPublicBooking', createGetPublicBookingAction],
  ['GetPublicBookingCalendar', createGetPublicBookingCalendarAction],
  ['GetPublicBookingInvoicePdf', createGetPublicBookingInvoicePdfAction],
  ['GetReservationDetail', createGetReservationDetailAction],
  ['GetReservationCalendar', createGetReservationCalendarAction],
  ['CancelReservation', createCancelReservationAction],
  ['ManageReservationGuestAccess', createManageReservationGuestAccessAction],
  ['GetReservationPayment', createGetReservationPaymentAction],
  ['RefreshReservationPayment', createRefreshReservationPaymentAction],
  ['GetPublicReservationPayment', createGetPublicReservationPaymentAction],
  ['RefreshPublicReservationPayment', createRefreshPublicReservationPaymentAction],
  ['GetReservationInvoicePdf', createGetReservationInvoicePdfAction],
  ['GetReservationInvoiceIsdoc', createGetReservationInvoiceIsdocAction],
  ['GetPublicReservationInvoicePdf', createGetPublicReservationInvoicePdfAction],
  ['GetPublicReservationInvoiceIsdoc', createGetPublicReservationInvoiceIsdocAction],
  ['AcceptReservation', createAcceptReservationAction],
  ['MarkReservationPaid', createMarkReservationPaidAction],
  ['MarkReservationCreditPurchasePaid', createMarkReservationCreditPurchasePaidAction],
  ['CreateManualCreditGrant', createCreateManualCreditGrantAction],
  ['GetReservableSpaceStatistics', createGetReservableSpaceStatisticsAction],
  ['GetAirConditioner', createGetAirConditionerAction],
  ['SetAirConditionerCharacteristic', createSetAirConditionerCharacteristicAction],
  ['GetDaikinAuthStatus', createGetDaikinAuthStatusAction],
  ['StartDaikinAuth', createStartDaikinAuthAction],
  ['SyncDaikinDevices', createSyncDaikinDevicesAction],
] as any);
